import * as React from 'react';
import { useSelector } from 'react-redux';

import { SalesDescription } from '../../components/SalesDescription';
import { getSalesDescription } from '../../selectors/getSalesDescription';

export function SalesDescriptionContainer() {
  const description = useSelector(getSalesDescription);
  const descriptionText = React.useMemo(() => (description ? description.text.split('\n') : []), [description]);

  if (!description) {
    return null;
  }

  return <SalesDescription text={descriptionText} type={description.salesType} />;
}
